module.exports = __webpack_public_path__ + "img/odwh3_v2_element_04.74364922.png";